import { resolveValidationState } from './utils';
import { unmaskValue } from '../TextInput/utils/unmaskValue';
export const validatorFactory = (setValidationState, hasError, errorMessage, isSuccessful, successMessage, customErrorMessages, helpMessage, required, label) => {
  return {
    validate: (value, validationParams, rules, updateState) => {
      const validationParameters = {
        customErrorMessages,
        errorMessage,
        hasError,
        successMessage,
        isSuccessful,
        helpMessage,
        required,
        label,
        ...validationParams
      };
      let validationState = resolveValidationState(helpMessage, hasError, errorMessage, isSuccessful, successMessage);
      for (const rule of rules) {
        const normalizedValue = typeof value === 'string' ? unmaskValue(value, validationParameters.masking) : value;
        const ruleResults = rule(validationParameters, normalizedValue);
        if (ruleResults.triggered) {
          validationState = {
            ...ruleResults.validationState
          };
          break;
        }
      }
      if (updateState) {
        setValidationState(validationState);
      }
      return validationState;
    },
    reset: () => {
      const validationState = resolveValidationState(helpMessage, hasError, errorMessage, isSuccessful, successMessage);
      setValidationState(validationState);
      return validationState;
    }
  };
};